import React from 'react';

/**
 * SUSPEND AI ANİMASYONU — 21st.dev "ai-loader" (beratberkayg) BİREBİR UYARLAMASI
 *
 * KAYNAK KODA GÖRE DEĞİŞEN ÜÇ ŞEY, BAŞKA HİÇBİR ŞEY:
 *
 * 1) Metin: `text = "Generating"` -> `text = "Suspend AI"` (Selçuk'un açık isteği).
 *    Metindeki BOŞLUK için ` ` (kırılmaz boşluk) kullanılır. Gerekçe: her harf
 *    `inline-block` bir <span> içine konuyor; içinde yalnızca normal boşluk olan
 *    inline-block bir kutunun genişliği sıfıra iner ve ekranda "SuspendAI" yazardı.
 *    Kaynak metin ("Generating") boşluk içermediği için bu durum orada hiç oluşmuyordu.
 *
 * 2) Tip tanımları silindi (proje saf JavaScript, TypeScript yok).
 *
 * 3) `<style jsx>` bloğu kaldırıldı; içindeki CSS `src/App.css` sonuna
 *    `.wh-suspend-` önekiyle, DEĞERLERİ HİÇ DEĞİŞTİRİLMEDEN taşındı.
 *    Gerekçe: `<style jsx>` Next.js'e özgü `styled-jsx` eklentisini ister,
 *    bu projede (CRA + Craco) kurulu değildir ve yeni bağımlılık kurmak yasaktır.
 *    Sınıf adları yalnızca öneklendi:
 *      .animate-loaderCircle -> .wh-suspend-animate-loaderCircle
 *      .animate-loaderLetter -> .wh-suspend-animate-loaderLetter
 *      @keyframes loaderCircle/loaderLetter -> wh-suspend-loaderCircle/-loaderLetter
 *
 * KAPSAYICI: Kaynakta dış katman `fixed inset-0 z-50` ile tam ekranı kaplar.
 * Bu bileşen bir kartın içine gömüldüğü için o üç sınıf düşürüldü, yerine
 * `relative` geldi. Gradyan (`from-[#1a3379] via-[#0f172a] to-black`),
 * `size`, tüm animasyonlar aynen korundu.
 *
 * ═══════════════════════════════════════════════════════════════════
 * `dark:` VARYANTLARI NEDEN KALDIRILDI — İSTENEN GÖRÜNTÜ BU
 * ═══════════════════════════════════════════════════════════════════
 * Kaynak kodda `dark:from-gray-100 dark:via-gray-200 dark:to-gray-300` ve
 * `dark:text-gray-800` vardı. Ana sitenin teması `class` tabanlı
 * (`tailwind.config.js` → `darkMode: ["class"]`) ve site VARSAYILAN OLARAK
 * KOYU açılıyor (`public/index.html:2` → `<html class="dark">`).
 *
 * O varyantlar bırakılsaydı, WhowSell'in koyu temasında bu kutu AÇIK GRİ
 * zeminde KOYU GRİ yazı olarak çizilecekti. Tarayıcıda ölçüldü:
 *   koyu temada gradyan -> rgb(243,244,246) → rgb(229,231,235) → rgb(209,213,219)
 *   koyu temada yazı    -> rgb(31,41,55)
 * Bu, istenen görüntünün TAM TERSİ: referans lacivert→siyah zeminde
 * beyaz yazı.
 *
 * Kaynak bileşen, açık temalı bir sitede tam ekran yükleme perdesi olarak
 * kullanılmak üzere yazılmış; `dark:` dalı O bağlamda anlamlıydı. Burada
 * bağlam farklı — dolayısıyla "birebir" olan şey satırı korumak değil,
 * GÖRÜNTÜYÜ korumak. Renkler, gölgeler, süreler, keyframe'ler kaynakla aynı.
 */
export default function SuspendAiLoader({ size = 180, text = 'Suspend AI' }) {
  const letters = text.split('');
  return (
    <div className="wh-suspend-sahne relative flex items-center justify-center bg-gradient-to-b from-[#1a3379] via-[#0f172a] to-black">
      <div
        className="relative flex items-center justify-center font-inter select-none"
        style={{ width: size, height: size }}
      >
        {letters.map((letter, index) => (
          <span
            key={index}
            className="inline-block text-white opacity-40 wh-suspend-animate-loaderLetter"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            {letter === ' ' ? ' ' : letter}
          </span>
        ))}
        <div className="absolute inset-0 rounded-full wh-suspend-animate-loaderCircle"></div>
      </div>
    </div>
  );
}
